import React from 'react';
import moment from 'moment';

import { convertColumnsForSmallWidth, TableLibrary } from 'src/components/complex';
import BaseComponent from 'src/components/BaseComponent';

import { withRouter, isAdminPage } from 'src/helpers';

import model from './model';

class DoctorStats extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
    if (!model.initFlag) {
      model.refresh();
      model.initFlag = true;
    }
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    model.initFlag = false;
  }

  render() {
    let loading = model.refreshing();
    let noResults = model.noResults();
    let searchQuery = model.listInput('search');
    let items = model.items();

    const columns = [
      {
        label: 'Date',
        sort: { sortKey: 'date' },
        // resize: true,
        // minWidth: '150',
        renderCell: (item) => {
          return moment(item.created).format('D MMM, YYYY');
        }
      },
      {
        label: 'Type',
        resize: true,
        // width: '10%',
        // minWidth: '80',
        renderCell: (item) => item.targetType
      },
      {
        label: 'Earnings',
        // minWidth: '150',
        // cellStyles: { textAlign: 'end' },
        renderCell: (item) => {
          let result = isAdminPage() ? item.originAmount : item.doctorFee;
          return `${result} ${item.currency}`;
        }
      }
    ];

    return (
      <TableLibrary
        loading={loading}
        noResults={noResults}
        searchQuery={searchQuery}
        sortBy={model.state.sortBy}
        selectedPage={model.state.pageIndex}
        // total={total}
        limit={model.listLimit}
        showPagination={false}
        onSortChange={(sortBy) => {
          model.handleChange('sortBy', sortBy);
          model.setListState({ items: [] }, model.getCurrentId(), null, true);
          model.loadMore();
        }}
        onSetPage={(v) => {
          model.handleChange('pageIndex', v);
          model.setListState({ items: [] }, model.getCurrentId(), null, true);
          model.loadMore();
        }}
        columns={
          this.props.screenDetail?.innerWidth < 1180
            ? convertColumnsForSmallWidth(columns)
            : columns
        }
        showHeader={this.props.screenDetail?.innerWidth >= 1180}
        data={items}
      />
    );
  }
}

export default withRouter(DoctorStats);
